import { render } from "./HoraList.vue?vue&type=template&id=629bd8b8"
import script from "./HoraList.vue?vue&type=script&lang=js"
export * from "./HoraList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__